import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Flex, Image, Spin } from 'antd';
import {
  useCreateShopInformationFile,
  useDeleteShopInformationFile,
} from 'hooks/ShopInformationFileHooks';
import React from 'react';
import MessageAlert, { STORE_URL } from 'utils';
import { FileManager } from 'utils/FileManager';

const ShopUploadFile = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { file = null, type = 'THUMBNAIL', shopId, callback } = props;

  /* ===== Mutate ===== */
  const { createShopInformationFile } = useCreateShopInformationFile();
  const { deleteShopInformationFile } = useDeleteShopInformationFile();

  /* ===== State ===== */
  const fileRef = React.useRef(null);
  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /**
   * 파일 핸들러
   * --
   * @param {string} t
   * @param {File} f
   * @returns
   */
  const handleFileChange = async (t, f) => {
    const submitType = t.toLocaleUpperCase();

    const confirm = (msg = '') => window.confirm(msg);

    let d = null;
    try {
      setIsLoading(true);

      switch (submitType) {
        case 'DELETE':
          if (
            !confirm(
              '등록된 파일을 삭제하시겠습니까?\n삭제 후 복구할 수 없습니다.'
            )
          )
            return;

          const deleteFile = await deleteShopInformationFile(
            f?.shop_information_file_id
          );

          if (deleteFile.status !== 200) {
            MessageAlert.info('파일 삭제에 실패하였습니다.');
            return;
          }

          MessageAlert.success('파일이 성공적으로 삭제되었습니다.');
          d = null;
          break;
        case 'UPLOAD':
          const upload = await FileManager.upload(`${shopId}`, f);

          if (upload.status !== 200) {
            MessageAlert.info('파일 업로드에 실패하였습니다.');
            return;
          }

          const create = await createShopInformationFile({
            file_name: upload?.data?.origin_name,
            file_url: upload?.data?.file_name,
            shop_information_id: shopId,
            type: type,
          });

          if (create.status !== 200) {
            MessageAlert.info('파일 업로드에 실패하였습니다.');
            return;
          }

          MessageAlert.success('파일 업로드에 성공하였습니다.');
          d = create.data;

          callback && callback(create.data);
          break;
        default:
          MessageAlert.info('파일 관리에 실패하였습니다!');
          return;
      }
    } catch (err) {
      console.error('[handleFileChange] Error!! ', err);
      MessageAlert.error('파일 관리에 실패하였습니다!');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setData(d);
      }, 1000);
    }
  };

  /* ===== Variable ===== */
  const fileWidth = React.useMemo(() => {
    const width = {
      THUMBNAIL: {
        width: 150,
        height: 96,
      },
      STORE: {
        width: 200,
        height: 46,
      },
      LICENSE: {
        width: 80,
        height: 150,
      },
    };

    return width[type];
  }, [type]);

  /* ===== Hooks ===== */
  React.useEffect(() => {
    if (file) {
      setData(file);
    } else {
      setData(null);
    }
  }, [file]);

  /* ===== Render ===== */
  return (
    <Spin spinning={isLoading}>
      <div>
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          onChange={(e) => handleFileChange('upload', e.target.files[0])}
          style={{ display: 'none' }}
        />
        {!data ? (
          <Button
            icon={<UploadOutlined />}
            onClick={() => fileRef.current.click()}
          >
            파일등록
          </Button>
        ) : (
          <Flex gap={10} justify="center" align="center">
            <Image
              src={
                data?.shop_information_file_id
                  ? `${STORE_URL}/${data?.file_url}`
                  : URL.createObjectURL(data)
              }
              alt={`${data?.file_name}`}
              style={{ ...fileWidth }}
            />

            <Button
              size="small"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleFileChange('delete', data)}
            />
          </Flex>
        )}
      </div>
    </Spin>
  );
};

export default ShopUploadFile;
